var map = {
	"./01_CocoaPop_Chocolate_Bomb/01_materializing_magic_sparkle.mp3": [
		98668,
		[
			8668
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/02_rumbling_volcano.mp3": [
		66871,
		[
			6871
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/03_cracking_shell.mp3": [
		38676,
		[
			8676
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/04_popping_explosion.mp3": [
		98633,
		[
			8633
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/05_comic_pop_text.mp3": [
		70280,
		[
			280
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/06_goat_scream.mp3": [
		40317,
		[
			317
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/07_bruh_sound.mp3": [
		59334,
		[
			9334
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/08_vine_boom.mp3": [
		90214,
		[
			214
		]
	],
	"./01_CocoaPop_Chocolate_Bomb/09_taco_bell_bong.mp3": [
		6599,
		[
			6599
		]
	],
	"./02_DryPull_Sad_Moment/1/01_hopeful_music_sting.mp3": [
		37681,
		[
			7681
		]
	],
	"./02_DryPull_Sad_Moment/1/02_question_bing.mp3": [
		96318,
		[
			6318
		]
	],
	"./02_DryPull_Sad_Moment/1/03_sad_trombone_crumple.mp3": [
		66494,
		[
			6494
		]
	],
	"./02_DryPull_Sad_Moment/1/04_wind_tumbleweed.mp3": [
		18066,
		[
			8066
		]
	],
	"./02_DryPull_Sad_Moment/1/05_tear_drop_plop.mp3": [
		39362,
		[
			9362
		]
	],
	"./02_DryPull_Sad_Moment/1/06_sad_violin.mp3": [
		79946,
		[
			7565
		]
	],
	"./02_DryPull_Sad_Moment/1/07_oof_sound.mp3": [
		42982,
		[
			2982
		]
	],
	"./02_DryPull_Sad_Moment/1/08_windows_shutdown.mp3": [
		61811,
		[
			1811
		]
	],
	"./02_DryPull_Sad_Moment/1/09_price_is_right_horn.mp3": [
		71215,
		[
			1215
		]
	],
	"./02_DryPull_Sad_Moment/1/10_hello_darkness.mp3": [
		29344,
		[
			9344
		]
	],
	"./02_DryPull_Sad_Moment/1/11_oh_no_table.mp3": [
		69243,
		[
			9243
		]
	],
	"./02_DryPull_Sad_Moment/Homer.m4a": [
		35139,
		[
			5139
		]
	],
	"./02_DryPull_Sad_Moment/Spongebob Sad - Sound Effect(HD).mp3": [
		51139,
		[
			1139
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/01_toilet_fill_buildup.mp3": [
		33634,
		[
			3634
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/02_flush_whoosh.mp3": [
		92473,
		[
			2473
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/03_splash_bubbles.mp3": [
		44720,
		[
			4720
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/04_empty_bowl_echo.mp3": [
		16942,
		[
			6942
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/05_wet_fart_tier2.mp3": [
		90898,
		[
			898
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/06_sewer_monster_tier3.mp3": [
		48525,
		[
			8525
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/07_plunger_pop_tier4.mp3": [
		63823,
		[
			3823
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/08_tp_roll_empty_tier5.mp3": [
		91108,
		[
			1108
		]
	],
	"./02_DryPull_Sad_Moment/flow1_flush/09_fan_death_tier6.mp3": [
		41166,
		[
			1166
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/01_villain_buildup.mp3": [
		45976,
		[
			5976
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/02_rug_rip_swipe.mp3": [
		96873,
		[
			6873
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/03_falling_scream.mp3": [
		54956,
		[
			4956
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/04_empty_wallet_wind.mp3": [
		15008,
		[
			5008
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/05_empty_register_tier2.mp3": [
		11587,
		[
			1587
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/06_snake_hiss_tier3.mp3": [
		54426,
		[
			4426
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/07_police_siren_tier4.mp3": [
		90386,
		[
			386
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/08_villain_laugh_fade_tier5.mp3": [
		93966,
		[
			3966
		]
	],
	"./02_DryPull_Sad_Moment/flow2_rugpull/09_cockroach_scatter_tier6.mp3": [
		2160,
		[
			2160
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/01_macho_buildup.mp3": [
		27300,
		[
			7300
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/02_deflate_raspberry.mp3": [
		93129,
		[
			3129
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/03_tiny_squeak.mp3": [
		17477,
		[
			7477
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/04_crickets_silence.mp3": [
		4711,
		[
			4711
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/05_slide_whistle_tier2.mp3": [
		30131,
		[
			131
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/06_dog_whimper_tier3.mp3": [
		31182,
		[
			1182
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/07_air_horn_fail_tier4.mp3": [
		2232,
		[
			2232
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/08_tiny_violin_tier5.mp3": [
		2539,
		[
			2539
		]
	],
	"./02_DryPull_Sad_Moment/flow3_deflated/09_micro_boing_tier6.mp3": [
		91117,
		[
			1117
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/01_horny_breathing.mp3": [
		55917,
		[
			5917
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/02_bonk_hit.mp3": [
		49841,
		[
			9841
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/03_dazed_chirps.mp3": [
		19066,
		[
			9066
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/04_jail_door_slam.mp3": [
		19304,
		[
			9304
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/05_rejection_horn_tier2.mp3": [
		10694,
		[
			694
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/06_chain_rattle_tier3.mp3": [
		65229,
		[
			5229
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/07_buzzer_wrong_tier4.mp3": [
		73645,
		[
			3645
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/08_crying_club_tier5.mp3": [
		22888,
		[
			2888
		]
	],
	"./02_DryPull_Sad_Moment/flow4_bonk/09_lock_click_tier6.mp3": [
		88037,
		[
			8037
		]
	],
	"./02_DryPull_Sad_Moment/sad_horn.m4a": [
		61182,
		[
			8801
		]
	],
	"./03_NutPop_Treasure_Eruption/01_glassy_descend.mp3": [
		67646,
		[
			7646
		]
	],
	"./03_NutPop_Treasure_Eruption/02_pressure_steam.mp3": [
		21765,
		[
			1765
		]
	],
	"./03_NutPop_Treasure_Eruption/03_cracking_shell.mp3": [
		58747,
		[
			8747
		]
	],
	"./03_NutPop_Treasure_Eruption/04_treasure_burst.mp3": [
		48159,
		[
			8159
		]
	],
	"./03_NutPop_Treasure_Eruption/05_victory_fanfare.mp3": [
		62192,
		[
			2192
		]
	],
	"./03_NutPop_Treasure_Eruption/06_slot_jackpot.mp3": [
		36426,
		[
			6426
		]
	],
	"./03_NutPop_Treasure_Eruption/07_mlg_airhorn.mp3": [
		29410,
		[
			9410
		]
	],
	"./03_NutPop_Treasure_Eruption/08_oh_baby_triple.mp3": [
		18436,
		[
			8436
		]
	],
	"./03_NutPop_Treasure_Eruption/09_money_money.mp3": [
		95929,
		[
			5929
		]
	],
	"./03_NutPop_Treasure_Eruption/10_mario_coins.mp3": [
		62901,
		[
			2901
		]
	],
	"./04_ShaftBerry_Neon_Overload/01_electric_charging.mp3": [
		8993,
		[
			8993
		]
	],
	"./04_ShaftBerry_Neon_Overload/02_bass_pulse.mp3": [
		96466,
		[
			6466
		]
	],
	"./04_ShaftBerry_Neon_Overload/03_electric_zap.mp3": [
		93951,
		[
			3951
		]
	],
	"./04_ShaftBerry_Neon_Overload/04_lightning_laser.mp3": [
		81235,
		[
			1235
		]
	],
	"./04_ShaftBerry_Neon_Overload/05_comic_zap.mp3": [
		32031,
		[
			2031
		]
	],
	"./04_ShaftBerry_Neon_Overload/06_matrix_rain.mp3": [
		38527,
		[
			8527
		]
	],
	"./04_ShaftBerry_Neon_Overload/07_dbz_powerup.mp3": [
		58223,
		[
			8223
		]
	],
	"./04_ShaftBerry_Neon_Overload/08_electro_shock.mp3": [
		75930,
		[
			5930
		]
	],
	"./04_ShaftBerry_Neon_Overload/09_lightsaber.mp3": [
		55187,
		[
			5187
		]
	],
	"./04_ShaftBerry_Neon_Overload/10_wifi_connect.mp3": [
		71630,
		[
			1630
		]
	],
	"./04_ShaftBerry_Neon_Overload/11_unlimited_power.mp3": [
		93960,
		[
			3960
		]
	],
	"./05_SlapTaffy_Slap_Attack/01_winding_whoosh.mp3": [
		92724,
		[
			2724
		]
	],
	"./05_SlapTaffy_Slap_Attack/02_slapping_whoosh.mp3": [
		66413,
		[
			6413
		]
	],
	"./05_SlapTaffy_Slap_Attack/03_impact_slap.mp3": [
		70216,
		[
			216
		]
	],
	"./05_SlapTaffy_Slap_Attack/04_wobbling_boing.mp3": [
		67184,
		[
			7184
		]
	],
	"./05_SlapTaffy_Slap_Attack/05_comic_slap_variation.mp3": [
		42021,
		[
			2021
		]
	],
	"./05_SlapTaffy_Slap_Attack/06_combo_counter.mp3": [
		64145,
		[
			4145
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 1 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 13503;
module.exports = webpackAsyncContext;